<template>
    <div class="salesmanmember2Page">  
      <XR-edit-head :titleText="saleMenCategory?saleMenCategory[0]:'普通会员'" :rightButtonText="'管理'" :rightButtonShow="editButtonShow" ref="head" @editEvent="editEvent" @completeEvent="completeEvent" ></XR-edit-head> 
      <div :style="'margin-bottom:'+ height + 'px'">
	  <mu-list class="account-info" ref="memberList">
          <mu-list-item class="list" v-for="mItem in memberList.List" :key="mItem.minnerbm">
          <div class="mu-item-title">
              <mu-checkbox class="cart-chk" :nativeValue="mItem.userbm" v-model="checkList" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-check-circle" slot="left" v-if="mode=='edit'" />    
              <div class="dd3">
                <img :src="mItem.headPic" alt="">
              </div>
              <div class="dd1">
                <p>{{mItem.userbm}}</p>             
                <p class="telephone">{{mItem.mobile}}</p>
                <p class="number">{{mItem.reallyname}}</p>
              </div>
              <div class="dd1 dd2">
                <p >{{mItem.zcpvname}}</p>
                <p style="color:red;">{{mItem.IsApply?'待审核':''}}</p>
                <p class="date">{{mItem.shsjname}}</p>            
              </div>
          </div>
        </mu-list-item> 
      </mu-list>
      </div>
      <div class="bottom-bar" v-if="mode =='edit'">
          <mu-row >
          <mu-col width="100" tablet="100" desktop="100">        
              <mu-checkbox v-model="isChkAll" label="全选" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-check-circle" @change="chkAll()" class="cart-all-chk"/>
              <mu-raised-button class="operatorBtn" @click="gofenliu()" label="分流" />
              <mu-raised-button class="operatorBtn" @click="openDialog()" label="升级" />
          </mu-col>
          </mu-row>
      </div>
      <mu-dialog :open="dialog" title="请输入支付密码" @close="closeDialog">
        <p>升级众创会员需要使用金币支付费用</p>
        <mu-text-field hintText="支付密码" type="password" v-model="payPassword" v-if="safeInfo.IsMpass" />
        <router-link :to="'/usercenter/payPassword?redirect_url='+localUrl" v-if="!safeInfo.IsMpass">尚未设置支付密码，点击设置</router-link>
        <mu-flat-button slot="actions" @click="closeDialog" primary label="取消"/>
        <mu-flat-button slot="actions" primary @click="upgradeMember" label="确定"/>
      </mu-dialog>
      <XR-toast @onClose="getMemberList" ref="XRtoast"></XR-toast>
      <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>
<script>
import {ErrorCode} from '../../util/errorcode'
import md5 from 'js-md5'
export default {
  data () {
    return {  
      loaded:true, 
      appHeigth:document.documentElement.clientHeight,   
      searchInfo:{
        pageIndex:1,
        pageSize:1000,
        zcpv:0,
        shbs:0,
        startdate:'',
        enddate:'',
        e:1
      },
      memberList:{},
      mode: this.$route.query.mode?this.$route.query.mode:'normal', //如果mode=normal，则代表正常，如果mode=select，则代表选择模式，选中即跳转回去
      editButtonShow: this.$route.query.mode == 'select' ?false:true,
      checkList:[],
      isChkAll: false,
      checkAllList:[],    
      payPassword:'',
      dialog : false,
      safeInfo:{
      IsMpass:false
      },
      localUrl: encodeURIComponent(window.location.href),
	  height:0,
	  saleMenCategory:window.localStorage.saleMenCategory.split(",")
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load('加载中...')
    this.getUserSafe()
    this.getMemberList()   
  },  
  methods:{ 
    getUserSafe(){   
      var ths = this
      ths.$post(
        "/Salesman/UserServer/GetUserSafeInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRPageTip.ShowEmpty(res.Msg)
        }else{  
          ths.safeInfo = res.Data
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },    
    getMemberList(){          
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetMyShopMemberStream", this.searchInfo)
      .then(function(res) {
        ths.$refs.XRtoast.hide();
        if (res.IsSuccess) {          
          ths.memberList = res.Data
          for(var i = 0; i< ths.memberList.List.length;i++){
            ths.checkAllList.push(ths.memberList.List[i].userbm)
          }
          ths.$refs.XRPageTip.initTip()
        }
        else{
          ths.editButtonShow =false
          ths.memberList = {}
          ths.checkAllList=[]
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },   
    editEvent: function(){  
      this.mode='edit'     
      this.height=56;
    }, 
    completeEvent: function(){
      this.mode='normal';
      this.height=0;
    },
    chkAll: function(){
      if(!this.isChkAll){
        this.checkList = this.checkAllList
      }else {
        this.checkList = []
      }
    },
    gofenliu(){
      if(this.checkList.length ==0){
        this.$refs.XRtoast.failed('请选择要分流的会员', true);
        return
      }
      var userNames = []
      for(var i = 0;i<this.checkList.length;i++){
        userNames.push(this.checkList[i])
      }
      this.$router.push('/salesman/fenliustore?userNames='+userNames.join(','))
    },
    
    openDialog () {
      if(this.checkList.length ==0){
        this.$refs.XRtoast.failed('请选择要升级的会员', true);
        return
      }

      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },  
    upgradeMember(){
      var userNames = []
      for(var i = 0;i<this.checkList.length;i++){
        userNames.push(this.checkList[i])
      }
      
      this.closeDialog()       
      var ths = this

      if(!this.payPassword){
          ths.$refs.XRtoast.failed("请输入支付密码", true)
          return
      }
      ths.payPassword = md5(ths.payPassword)

      ths.$post(
        "/Salesman/SalesmanServer/UpgradeMember", {userNameList:userNames, payPassword: ths.payPassword}
      ).then(function(res) {
        ths.payPassword =''
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{   
          ths.checkList = []         
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    }
  }
}

</script>
<style>
      body .salesmanmember2Page{
        background: #fff;
      }
      .salesmanmember2Page .mu-appbar .mu-appbar-title{
        font-size: 16px;
      }
      .salesmanmember2Page .account-info{
        background: #fff;
        padding: 0;
      }
       .salesmanmember2Page .list .mu-item{
          border-bottom: 1px solid #f5f5f5;
        }
        .salesmanmember2Page .mu-list .list:last-child .mu-item{
          border-bottom: 0;
        }
      .salesmanmember2Page .dd1
        {
            float:left;
            width: 50%;
            padding-left: 5%;
            text-align:left;
            font-size:13px;
        }
        .salesmanmember2Page .dd1{
          font-size: 12px;
        }
        .salesmanmember2Page .dd1 .number{color: #999;}       
        .salesmanmember2Page .dd2 .date { font-size:12px; color: #999;}
        .salesmanmember2Page .dd2
        {
            float:left;
            width:30%;
            text-align:right;
            padding-left:2%;
        }
        .salesmanmember2Page .mu-list .mu-checkbox{
          float: left;
          width: 10%;
          margin-top: 5px;
        }
         .salesmanmember2Page .mu-checkbox .mu-checkbox-icon-uncheck, .salesmanmember2Page .mu-checkbox-icon-checked {
            font-size: 18px;
            margin-top: 3px;
            
        }
        
      .salesmanmember2Page .dd2 .type { font-size:13px;}
      .salesmanmember2Page .dd2 .telephone{
        font-size: 12px;
      }
      .salesmanmember2Page .dd3
        {
            float:left;
            width:10%;
            text-align:center;

        }
        .salesmanmember2Page .dd3 img{
          width: 35px;
          height: 35px;
          border-radius: 50%;
          object-fit: cover;
        }
       .salesmanmember2Page .dd3 .btn
        {
          background-color: #e2000e;
          color: #fff;
          display: block;
          width: 60px;
          height: 18px;
          font-size: 12px;
          margin-top: 9px;
          margin-left: 10%;
          float: right;
        }
       .salesmanmember2Page .mu-raised-button{
          min-width: 0px;
        }
       .salesmanmember2Page .dd3 a.huihui
        {
            font-size:12px;
            background:#999;
            cursor:inherit;
        }


      .salesmanmember2Page .bottom-bar{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
        height: 56px;
        border-top:1px solid #eee;
      }
      .salesmanmember2Page ,.bottom-bar .mu-checkbox-icon{
        margin-right: 0px; 
      }
      .salesmanmember2Page .bottom-bar .cart-all-chk{
        float: left;
        height: 24px;
        margin: 16px 0 16px 5%;
      }
      .salesmanmember2Page .bottom-bar .operatorBtn{
        float: left;
        height: 56px;
        font-size: 12px;
        float: right;
        background: red;
        color: #fff;
        width: 25%;
      }
      .salesmanmember2Page .bottom-bar .mu-checkbox.label-left .mu-checkbox-icon {
        margin-top: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/mymemberlist.vue